<template>
  <div id="templatePane">
    <div class="hero-section shade-40">
      <div class="hero-section-text row column">
        <h1>Workplace - a whole new way to collaborate</h1>
        <p>With Workplace you'll find it even easier to work and collaborate with colleagues across the business.</p>
        <p>To get started, we need to do some quick checks to make sure we keep everything secure.  Don't worry, you'll be up and running in no time.</p>
      </div>
    </div>
    <section id="mainContent" class="row column">
      <form data-abide novalidate id="signin">
        <div data-abide-error class="alert callout" style="display: none;">
          We've been unable to sign you in.
        </div>
        <div>
          <label for="username">Email address</label>
          <input type="email" id="username" required />
          <span class="form-error" data-form-error-for="username">This needs to be your email address</span>
        </div>
        <div>
          <label for="password">Password</label>
          <input type="password" id="password" required />
          <span class="form-error" data-form-error-for="password">This needs to be your IUSER password</span>
        </div>
        <a href="phonenumber.html" class="button" type="button">Sign in</a>
        {{!--<button id="submitButton" type="submit" class="button">Sign in</button>--}}
      </form>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'SignIn',
    title: 'Workplace - Sign in to your account'
  }
</script>
